import { TFunction } from 'i18next'
import { RoleType } from 'zens-store'

export function titleForRole(role: RoleType | undefined, t: TFunction) {
  switch (role) {
    case RoleType.SystemAdministrator:
      return t('System Administrator')
    case RoleType.CompanyAdministrator:
      return t('Administrator')
    case RoleType.Operator:
      return t('Operator')
    case RoleType.Viewer:
      return t('Viewer')
    case RoleType.Facilitator:
      return t('Facilitator')
    case RoleType.External:
      return t('External')
    default:
      return t('Unknown')
  }
}
